<p>single-plan works!</p>
